import { AvailableFeatureFlags, RuntimeEnv } from "index";

/**
 * Gets the value of an environment variable.
 * @param variable Key of the environment variable from RuntimeEnv interface
 * @returns Value of the environment variable as string or undefined
 */
export function getEnvVariable(variable: keyof RuntimeEnv) {
  return window?.runtime_env?.[variable] || process?.env?.[variable];
}

/**
 * List of feature flags from REACT_APP_FEATURE_FLAGS.
 */
export const getFeatureFlags = getEnvVariable("REACT_APP_FEATURE_FLAGS")?.split(
  /\s*,\s*(?:,\s*)*/,
);

/**
 * Checks if a specific feature flag is active.
 * @param featureFlag Flag to check
 * @returns true if the flag is active, false otherwise
 */
export function checkIfFFExists(featureFlag: AvailableFeatureFlags) {
  return getFeatureFlags?.includes(featureFlag);
}
